import dayjs from "dayjs";

//import { useLocalStorage } from "../../../hooks/useLocalStorage";

const isoFormat = "YYYY-MM-DDTHH:mm:ss";
const fmt = (d) => dayjs(d).format(isoFormat);
const ms = (d) => new Date(d).getTime();


export const ReCalculateEndTimeForNewOrder = (startTime, plannedQty, reportedQty, itemOEE, speedUnitTypeId, idealCycleTime) => {
    //console.log("ReCalculateEndTimeForNewOrder called with:", startTime, plannedQty, itemOEE, speedUnitTypeId, idealCycleTime);
    return ReCalculateEndTime({ "plannedQty": plannedQty, "reportedQty": reportedQty, "idealCycleTime": idealCycleTime, "plannedStartTime": startTime },  speedUnitTypeId, itemOEE);
}

export const ReCalculateEndTime = (period, speedUnitTypeId, itemOEE) => {
    //calculated end time based on ideal speed remaing qty and OEE
    let idealTimeToEnd = 0;
    let idealRunTime = 0;
    let calcEndTime = null;


    let startTime = dayjs(period.replannedStartTime ?? period.plannedStartTime);

   // console.log ("ReCalculateEndTime called with period:", period, "speedUnitTypeId:", speedUnitTypeId, "itemOEE:", itemOEE);


    //let machineOEE = getOEEforMachine(item.machineId);
    //console.log("Calculating end time from", startTime.format(isoFormat), period.idealCycleTime, period.idealCycleTime, itemOEE, period.plannedQty, period.reportedQty, speedUnitTypeId);
    //itemOEE = itemOEE / 100; //convert to factor

    speedUnitTypeId = speedUnitTypeId?.speedUnitTypeId ?? speedUnitTypeId;

    //console.log ("ReCalculateEndTime called with speedUnitTypeId:", speedUnitTypeId);

    switch (speedUnitTypeId) {
        case 0: // Cycle time (s)
            idealTimeToEnd = period.idealCycleTime * (period.plannedQty - period.reportedQty) / itemOEE / 60; // in minutes
            calcEndTime = startTime.add(idealTimeToEnd, 'minute')?.format(isoFormat);
            idealRunTime = period.idealCycleTime * (period.plannedQty) / itemOEE / 60; // in minutes
            break;
        case 1: // Cycle time (s)
            //console.log("Calculating end time Start", startTime.format(isoFormat), period.idealCycleTime, itemOEE, period.plannedQty, period.reportedQty, speedUnitTypeId);
            //console.log("Calculating end time Test", 38.71 * (20001 - 0) / 1 / 60);
            //console.log ("Calculating end time Test", period.idealCycleTime?.toString() + " * (" + period.plannedQty?.toString() + " - " + period.reportedQty?.toString() + ") / " + itemOEE?.toString() + " / 60");
            idealTimeToEnd = period.idealCycleTime * (period.plannedQty - period.reportedQty) / itemOEE / 60; // in minutes
            //console.log ("idealTimeToEnd:", idealTimeToEnd);
            calcEndTime = startTime.add(idealTimeToEnd, 'minute')?.format(isoFormat);
            idealRunTime = period.idealCycleTime * (period.plannedQty) / itemOEE / 60; // in minutes
            //console.log("Calculating end time End 1", { "calcEndTime": calcEndTime, "idealTimeToEnd": idealTimeToEnd, "idealRunTime": idealRunTime });
            break;
        case 2: // Pace items/hour
            if (period.idealCycleTime > 0) {
                idealTimeToEnd = (period.plannedQty - period.reportedQty) / period.idealCycleTime * 60 / itemOEE; // in minutes
                calcEndTime = startTime.add(idealTimeToEnd, 'minute')?.format(isoFormat);
                idealRunTime = (period.plannedQty) / period.idealCycleTime * 60 / itemOEE; // in minutes
            } else {
                // if idealCycleTime is 0 (not set) we cannot calculate the end time so just use the planned end time
                ///???????
                calcEndTime = period.replannedEndTime ?? period.plannedEndTime;
            }
            break;
        case 3: // Speed m/min
            if (period.idealCycleTime > 0) {
                idealTimeToEnd = (period.plannedQty - period.reportedQty) / period.idealCycleTime / itemOEE; // in minutes
                calcEndTime = startTime.add(idealTimeToEnd, 'minute')?.format(isoFormat);
                idealRunTime = period.plannedQty / period.idealCycleTime / itemOEE; // in minutes
            } else {
                // if idealCycleTime is 0 (not set) we cannot calculate the end time so just use the planned end time
                ///???????
                calcEndTime = period.replannedEndTime ?? period.plannedEndTime;
            }
            break;
        case 4: // Speed kg/hour
        //console.log ("ReCalculateEndTime case 4 called");
            if (period.idealCycleTime > 0) {
                idealTimeToEnd = (period.plannedQty - period.reportedQty) / period.idealCycleTime * 60 / itemOEE; // in minutes
                calcEndTime = startTime.add(idealTimeToEnd, 'minute')?.format(isoFormat);
                idealRunTime = (period.plannedQty) / period.idealCycleTime * 60 / itemOEE; // in minutes
            } else {
                // if idealCycleTime is 0 (not set) we cannot calculate the end time so just use the planned end time
                ///???????
                calcEndTime = period.replannedEndTime ?? period.plannedEndTime;
            }
            break;

        default:
            // Default case if speedUnitTypeId is not recognized
            idealTimeToEnd = period.idealCycleTime * (period.plannedQty - period.reportedQty) / itemOEE / 60; // in minutes
            calcEndTime = startTime.add(idealTimeToEnd, 'minute')?.format(isoFormat);
            idealRunTime = period.idealCycleTime * (period.plannedQty) / itemOEE / 60; // in minutes
            break;
    }

    //console.log("Calculating end time End 2", { "calcEndTime": calcEndTime, "idealTimeToEnd": idealTimeToEnd, "idealRunTime": idealRunTime });
    return { "calcEndTime": calcEndTime, "idealTimeToEnd": idealTimeToEnd, "idealRunTime": idealRunTime };
}


export const GetSuggestedPlanningForMachine = (firstMachineClone, gapInMinutes, findRunning, scheduleRowsData, historicOeeDataQuery, defaultOee, firstUptime) => {
    let periods = [];
    let lastPeriod = null;
    // console.log(firstMachineClone?.name, "GetSuggestedPlanningForMachine called with firstMachineClone:", firstMachineClone, "machineid:", firstMachineClone?.id, "scheduleRowsQuery.data", scheduleRowsData.data,"findRunning", findRunning);

    let existingPlans = firstMachineClone?.periods?.filter((p) => p.type === "main") || [];
    const blockers = buildBlockers(existingPlans);

    // Build shifts/blockers for this machine
    const shifts = buildShiftsForMachine(scheduleRowsData.data, firstMachineClone.id);


    // console.log(firstMachineClone?.name, "[DEBUG] GetSuggestedPlanningForMachine shifts for machine:", firstMachineClone.name, shifts.length, "blockers:", blockers.length );
    // console.log(firstMachineClone?.name, "[DEBUG] GetSuggestedPlanningForMachine periods to replan:", firstMachineClone?.periods);

    firstMachineClone.periods.forEach((period, index) => {

        // console.log (firstMachineClone?.name, "[DEBUG] Loop:", index, period.productionOrderId,"Status:", period.erpStatus, "Last period:", lastPeriod,"periods", {...periods} );

        if (period.rowType.toString() === "2") {

            // Blocker, just push as is
            // console.log("Blocker period, pushing as is:", period);
            // console.log (firstMachineClone?.name, "[DEBUG] Skipping replanning for blocker:", period.productionOrderId, "period:",period);
            periods.push({ ...period, type: "replanned" });
            //lastPeriod = periods[periods.length - 1];

        } else {

            let percentLeft = 1 - (period.reportedQty / period.plannedQty);
            //let runningTimeLeft = period.calculatedRunTime * percentLeft;

            let runningTimeLeft = period.calculatedTimeToEnd;

            // Get historic OEE for item
            if (lastPeriod === null) {
                // Running

                // console.log (firstMachineClone?.name, "[DEBUG] lastPeriod === null", lastPeriod);

                //#### Runningtime left should be used?????

                if (findRunning === true) {
                    if (period.activePO.toString() === period.productionOrderId.toString()) {

                        if (firstUptime === null){
                            firstUptime = period.start || dayjs();
                        }

                        const placedA0 = placeWithShiftsAndBlockers({
                            startMs: ms(dayjs().format(isoFormat)),
                            workDurationMs: runningTimeLeft * 60000, //getWorkDurationMs(period),
                            shifts,
                            blockers,
                            gapMs: gapInMinutes * 60000,
                            label: "A-initial",
                        });
                        if (placedA0 !== null) {
                            //console.log (firstMachineClone?.name, "[DEBUG] Push pos:1", period.productionOrderId, "firstUptime:", firstUptime, "start:", period.start, "end:", placedA0.end, "Period:", period);
                            periods.push({ ...period, start: dayjs(firstUptime).format(isoFormat), end: dayjs(placedA0.end).format(isoFormat), type: "replanned" });
                            //periods.push({ ...period, start: dayjs().format(isoFormat), end: dayjs(placedA0.end).format(isoFormat), type: "replanned" });
                            
                            lastPeriod = {...periods[periods.length - 1]};
                        }
                    }
                } else {

                    // console.log (firstMachineClone?.name, "[DEBUG] period.erpStatus:", period.erpStatus);
                    if (period.erpStatus !== "9") { //Do not suggest new planning for completed orders

                        //Plan according to shift calendar
                        // console.log (firstMachineClone?.name, "[DEBUG] Plan order :", period.productionOrderId, "according to shift calendar");

                        const placedA0 = placeWithShiftsAndBlockers({
                            startMs: ms(dayjs().format(isoFormat)),
                            workDurationMs: runningTimeLeft * 60000, //getWorkDurationMs(period),
                            shifts,
                            blockers,
                            gapMs: gapInMinutes * 60000,
                            label: "A-initial",
                        });

                        // console.log (firstMachineClone?.name, "[DEBUG] Plan order :", period.productionOrderId, "startMS:", ms(dayjs().format(isoFormat)), "workDurationMs:", period.calculatedRunTime * 60000, "shifts:", shifts.length,"blockers:", blockers.length, "placedA0:", placedA0);
                        // console.log (firstMachineClone?.name, "[DEBUG] Plan order :", period.productionOrderId, "result:", placedA0);


                        if (placedA0 !== null) {
                           // console.log (firstMachineClone?.name, "[DEBUG] Push pos:2");
                            periods.push({ ...period, start: dayjs().format(isoFormat), end: dayjs(placedA0.end).format(isoFormat), type: "replanned" });

                            //periods.push({ ...period, start: dayjs().format(isoFormat), end: dayjs().add(period.calculatedRunTime, 'minute').format(isoFormat), type: "replanned" });
                            
                            lastPeriod = {...periods[periods.length - 1]};
                          
                            
                        }
                    } else {
                        // console.log (firstMachineClone?.name, "[DEBUG] Skipping replanning for completed order, find running:", period.productionOrderId, "period.erpStatus:", period.erpStatus);
                        //lastPeriod = periods[periods.length - 1];
                    }

                }
            } else {
                if (percentLeft > 0) {
                    if (period.erpStatus !== "9") { //Do not suggest new planning for completed orders

                        //Replan according to shift calendar

                        const placedA0 = placeWithShiftsAndBlockers({
                            startMs: ms(dayjs(lastPeriod.end).add(gapInMinutes, 'minute').format(isoFormat)),
                            workDurationMs: runningTimeLeft * 60000, //getWorkDurationMs(period),
                            shifts,
                            blockers,
                            gapMs: gapInMinutes * 60000,
                            label: "A-initial",
                        });

                        // console.log(firstMachineClone?.name, "[DEBUG] placeWithShiftsAndBlockers result for period", period.productionOrderId, lastPeriod.end, period, placedA0);
                        // console.log(firstMachineClone?.name, "[DEBUG] placeWithShiftsAndBlockers PlacedA", placedA0);

                        if (placedA0 === null) {
                            console.warn(firstMachineClone?.name, "[DEBUG] Could not place A within shifts horizon, placedA0 is null for period?", placedA0);

                            //######
                            return { ...firstMachineClone, periods: periods };

                            //return { replannedOrder: updatePOData, replannedOrders: [] };
                        }

                        // console.log(firstMachineClone?.name, "[DEBUG] placeWithShiftsAndBlockers result for periodx", period.productionOrderId, lastPeriod.end, period.productionOrderId, dayjs(placedA0.start).format(isoFormat), dayjs(placedA0.end).format(isoFormat), period.calculatedRunTime);

                        if (dayjs(lastPeriod.end).isAfter(period.start)) {

                            if (placedA0 !== null) {
                                // console.log (firstMachineClone?.name, "[DEBUG] Push pos:3");
                                //periods.push({ ...period, start: dayjs(lastPeriod.end).add(gapInMinutes, 'minute').format(isoFormat), end: dayjs(lastPeriod.end).add(period.calculatedRunTime, 'minute').format(isoFormat), type: "replanned" });
                                periods.push({ ...period, start: dayjs(lastPeriod.end).add(gapInMinutes, 'minute').format(isoFormat), end: dayjs(placedA0.end).format(isoFormat), type: "replanned" });
                            }
                        } else {
                            // console.log (firstMachineClone?.name, "[DEBUG] Push pos:4");
                            periods.push({ ...period, start: placedA0.start, end: dayjs(placedA0.end).format(isoFormat), type: "replanned" });
                        }
                        lastPeriod = {...periods[periods.length - 1]};
                    }
                } else {
                    // console.log (firstMachineClone?.name, "[DEBUG] Skipping replanning for completed order:", period.productionOrderId);
                    lastPeriod = {...periods[periods.length - 1]};
                }
            }

        }


    });


    let result = { ...firstMachineClone, periods: periods }

    // console.log (firstMachineClone?.name, "[DEBUG] Returning periods:", result, {...periods});

    //return firstmachineclone and clear periods
    return result;
}

// -------------------- ReplanMachine2 --------------------

// ReplanMachine2 with SHIFT schedules (allowed production windows) instead of weekend/nonprod rows.
// - Keeps snapToPrevious logic
// - Uses blockers (rowType 2) as forbidden intervals
// - Uses shifts (scheduleRows) as allowed intervals
// - Consumes workDurationMs only inside shifts (outside shifts = implicit nonprod)
// - Moves start out of blockers and out of non-shift time automatically
export const ReplanMachine2 = (
    period,
    machineOrders,
    machineName,
    gapInMinutes,
    snapToPrevious,
    replanOverlaps,
    recalculateAffectedOrders,
    companyKey,
    scheduleRows, // <-- NEW: array of shift rows
    historicOeeData, // <-- NEW: historic OEE data
    defaultOee
) => {


    //console.log("ReplanMachine2 called with period:", period, "machineOrders:", machineOrders, "machineName:", machineName, "gapInMinutes:", gapInMinutes, "snapToPrevious:", snapToPrevious, "replanOverlaps:", replanOverlaps, "recalculateAffectedOrders:", recalculateAffectedOrders, "companyKey:", companyKey, "scheduleRows:", scheduleRows, "historicOeeData:", historicOeeData, "defaultOee:", defaultOee);



    scheduleRows = scheduleRows?.data || [];
    //historicOeeData = historicOeeData?.data || [];

    // console.log ("ReplanMachine2-scheduleRows:", scheduleRows);
    // console.log ("ReplanMachine2-shistoricOeeData:", historicOeeData);


    const GAP_MS = (Number(gapInMinutes) || 0) * 60000;
    const REPLAN = replanOverlaps === true || replanOverlaps === "true";
    const SNAP = snapToPrevious === true || snapToPrevious === "true";

    const startTime = period.start;
    const endTime = period.end;
    const machineId = period.machineId;
    const productionOrderId = period.productionOrderId;

    // -------------------- Input / existing plan --------------------
    let periods = [];
    let existingPlans = machineOrders?.[0]?.periods?.filter((p) => p.type === "main") || [];

    // Build shifts/blockers for this machine
    const shifts = buildShiftsForMachine(scheduleRows, machineId);
    const blockers = buildBlockers(existingPlans);

    //console.log("[DEBUG] ReplanMachine2 shifts:", shifts.length, "blockers:", blockers.length);

    // If no shifts, we cannot schedule. Return unchanged.
    if (shifts.length === 0) {
        return { replannedOrder: { ...period }, replannedOrders: [] };
    }

    // Build updatePOData with stable workDuration
    //####
    // const baseWorkDurationMs = ms(period.plannedEndTime ?? period.end) - ms(period.plannedStartTime ?? period.start);
    const baseWorkDurationMs = getWorkDurationMs(period, historicOeeData, defaultOee); //59820000; // default 16.61 hours

    //console.log("ReplanMachine2: Base work duration (ms):", baseWorkDurationMs);


    let updatePOData = {
        ...period,
        //plannedStartTime: startTime,
        //plannedEndTime: endTime,
        start: startTime,
        end: endTime,
        replannedStartTime: startTime,
        replannedEndTime: endTime,
        plannedOrReplannedStartTime: startTime,
        plannedOrReplannedEndTime: endTime,
        workDurationMs: baseWorkDurationMs,
        extended: false,
    };

    // -------------------- Sanitize moved order A against shifts+blockers --------------------
    // (A should land where you drop it if possible; we do NOT add "gap before" here.)
    const placedA0 = placeWithShiftsAndBlockers({
        startMs: ms(startTime),
        workDurationMs: getWorkDurationMs(updatePOData, historicOeeData, defaultOee),
        shifts,
        blockers,
        gapMs: GAP_MS,
        label: "A-initial",
    });

    if (!placedA0) {
        console.warn("[DEBUG] Could not place A within shifts horizon");
        return { replannedOrder: updatePOData, replannedOrders: [] };
    }

    updatePOData = {
        ...updatePOData,
        replannedStartTime: fmt(placedA0.start),
        replannedEndTime: fmt(placedA0.end),
        plannedOrReplannedStartTime: fmt(placedA0.start),
        plannedOrReplannedEndTime: fmt(placedA0.end),
        start: fmt(placedA0.start),
        end: fmt(placedA0.end),
    };

    // Use sanitized times for overlap detection
    //updatePOData.plannedStartTime = updatePOData.replannedStartTime;
    //updatePOData.plannedEndTime = updatePOData.replannedEndTime;

    // -------------------- Find overlaps (for triggering chain replanning) --------------------
    const overlapsWith = (aStart, aEnd, bStart, bEnd) => ms(aStart) < ms(bEnd) && ms(aEnd) > ms(bStart);

    //console.log("[DEBUG] Checking overlaps for updated order:", {
    //     productionOrderId: updatePOData.productionOrderId,
    //     machineId: updatePOData.machineId,
    //     plannedOrReplannedStartTime: updatePOData.plannedOrReplannedStartTime,
    //     plannedOrReplannedEndTime: updatePOData.plannedOrReplannedEndTime,
    // }) ; 
    let firstOverlapArr = existingPlans.filter((o) => {
        if (o.machineId !== machineId) return false;
        if (o.productionOrderId === productionOrderId) return false;
        let result = overlapsWith(updatePOData.plannedOrReplannedStartTime, updatePOData.plannedOrReplannedEndTime, o.plannedOrReplannedStartTime, o.plannedOrReplannedEndTime);
        
        // console.log("Found overlap with order", o.productionOrderId, "overlap result:", result, "comparing", updatePOData.plannedOrReplannedStartTime, updatePOData.plannedOrReplannedEndTime, "with", o.plannedOrReplannedStartTime, o.plannedOrReplannedEndTime);
        
        return result;
    });

    // If overlapping includes blockers, keep last one (used by snapping logic)
    const blockersInOverlap = firstOverlapArr.filter((o) => o.rowType === 2);
    let lastBlockerInOverlap = blockersInOverlap.length ? blockersInOverlap[blockersInOverlap.length - 1] : null;

    let firstOverlap = (firstOverlapArr || [])
        .sort((a, b) => ms(a.plannedOrReplannedStartTime) - ms(b.plannedOrReplannedStartTime))[0];

    // -------------------- snapToPrevious (kept) --------------------
    if (SNAP) {
        let target = new Date(updatePOData.plannedOrReplannedStartTime);

        // ignore blockers/nonprod? (there is no nonprod now; only existing planned orders + blockers)
        const firstOverlapNotBlocker = existingPlans.filter((o) => {
            if (o.machineId !== machineId) return false;
            if (o.productionOrderId === productionOrderId) return false;
            if (o.rowType === 2) return false; // ignore blockers as "previous order"
            return overlapsWith(updatePOData.plannedOrReplannedStartTime, updatePOData.plannedOrReplannedEndTime, o.plannedOrReplannedStartTime, o.plannedOrReplannedEndTime);
        });

        let previousOrders = existingPlans.filter(
            (o) => o.machineId === machineId && 
                ms(o.plannedOrReplannedEndTime) <= ms(target) && 
                ms(o.plannedOrReplannedEndTime) >= ms(new Date()) &&   
                o.productionOrderId !== productionOrderId
                
        );

        // console.log ("[DEBUG] SnapToPrevious logic:", {
        //     firstOverlap: firstOverlap,
        //     firstOverlapNotBlocker: firstOverlapNotBlocker,
        //     previousOrders: previousOrders,
        // });

        if (firstOverlapNotBlocker && firstOverlapNotBlocker.length > 0) {
            // snap target to start of first overlapping normal order
            //console.log ("[DEBUG] SnapToPrevious: snapping to first overlap not blocker");
            const fo = firstOverlapNotBlocker.sort((a, b) => ms(a.plannedOrReplannedStartTime) - ms(b.plannedOrReplannedStartTime))[0];
            target = new Date(fo.plannedOrReplannedStartTime);

            previousOrders = existingPlans.filter(
                (o) =>
                    o.machineId === machineId &&
                    ms(o.plannedOrReplannedEndTime) <= ms(target) &&
                    ms(o.plannedOrReplannedEndTime) >= ms(new Date()) &&
                    o.rowType !== 2  &&// ignore blockers as "previous order"
                    o.productionOrderId !== productionOrderId
            );
        }

        let previousOrder = undefined;
        if (previousOrders.length > 0) {
            previousOrder = previousOrders.reduce((a, b) => (ms(a.plannedOrReplannedEndTime) > ms(b.plannedOrReplannedEndTime) ? a : b));
        }

        //console.log ("[DEBUG] SnapToPrevious: previousOrder selected:", previousOrder);


            // candidate start = now (if no previous order) or previous order end + gap
            let  candidateStart = ms(dayjs().format(isoFormat)); // default to now if no previous order

            // candidate start = prev.end + gap
            if (previousOrder) {
                candidateStart = ms(previousOrder.plannedOrReplannedEndTime) + GAP_MS;
            } 

            // keep work duration (or recalc if you want)
            const durationMs = getWorkDurationMs(updatePOData, historicOeeData, defaultOee);

            const placedSnap = placeWithShiftsAndBlockers({
                startMs: candidateStart,
                workDurationMs: durationMs,
                shifts,
                blockers,
                gapMs: GAP_MS,
                label: "A-snap",
            });

            if (placedSnap) {
                updatePOData = {
                    ...updatePOData,
                    replannedStartTime: fmt(placedSnap.start),
                    replannedEndTime: fmt(placedSnap.end),
                    plannedOrReplannedStartTime: fmt(placedSnap.start),
                    plannedOrReplannedEndTime: fmt(placedSnap.end),
                    start: fmt(placedSnap.start),
                    end: fmt(placedSnap.end),
                };

                //updatePOData.plannedStartTime = updatePOData.replannedStartTime;
                //updatePOData.plannedEndTime = updatePOData.replannedEndTime;
            }
        
    }

    // -------------------- Recursive chain replanning using shifts+blockers --------------------
    function replanAffectedRecursive({
        affectedOrders,
        cur,
        periods,
        keepReplanning,
    }) {
        if (!affectedOrders || affectedOrders.length === 0) {
            return { cur, periods, keepReplanning };
        }

        const [order, ...rest] = affectedOrders;

        if (!keepReplanning) {
            return replanAffectedRecursive({
                affectedOrders: rest,
                cur,
                periods,
                keepReplanning,
            });
        }

        let nextCur = cur ? { ...cur } : null;
        let nextPeriods = periods;

        if (!nextCur) {
            return replanAffectedRecursive({
                affectedOrders: rest,
                cur: nextCur,
                periods: nextPeriods,
                keepReplanning,
            });
        }

        // CASE B: if no overlap (including gap), we can stop moving chain here (keeps old plan)
        if (ms(nextCur.plannedOrReplannedEndTime) + GAP_MS <= ms(order.plannedOrReplannedStartTime)) {
            if (nextCur.rowType !== 2) nextPeriods = [...nextPeriods, { ...nextCur }];
            // stop the chain; leave the rest untouched
            return { cur: null, periods: nextPeriods, keepReplanning: false };
        }

        // If blocker row, keep it in output and move current after it
        if (order.rowType === 2) {
            nextPeriods = [...nextPeriods, { ...order }];

            const dur = getWorkDurationMs(nextCur, historicOeeData, defaultOee);
            const placed = placeWithShiftsAndBlockers({
                startMs: ms(order.plannedOrReplannedEndTime) + GAP_MS,
                workDurationMs: dur,
                shifts,
                blockers,
                gapMs: GAP_MS,
                label: "cur-after-blocker",
            });

            if (!placed) return { cur: null, periods: nextPeriods, keepReplanning: false };

            nextCur = {
                ...nextCur,
                replannedStartTime: fmt(placed.start),
                replannedEndTime: fmt(placed.end),
                plannedOrReplannedStartTime: fmt(placed.start),
                plannedOrReplannedEndTime: fmt(placed.end),
                start: fmt(placed.start),
                end: fmt(placed.end),
                workDurationMs: dur,
            };

            return replanAffectedRecursive({
                affectedOrders: rest,
                cur: nextCur,
                periods: nextPeriods,
                keepReplanning: true,
            });
        }

        // Normal order: push current and place this order after current (+gap), using shifts+blockers
        if (order.rowType === 1) {
            if (nextCur.rowType !== 2) nextPeriods = [...nextPeriods, { ...nextCur }];

            const dur = getWorkDurationMs(order, historicOeeData, defaultOee);
            const placed = placeWithShiftsAndBlockers({
                startMs: ms(nextCur.plannedOrReplannedEndTime) + GAP_MS,
                workDurationMs: dur,
                shifts,
                blockers,
                gapMs: GAP_MS,
                label: "order-after-cur",
            });

            if (!placed) return { cur: null, periods: nextPeriods, keepReplanning: false };

            nextCur = {
                ...order,
                replannedStartTime: fmt(placed.start),
                replannedEndTime: fmt(placed.end),
                plannedOrReplannedStartTime: fmt(placed.start),
                plannedOrReplannedEndTime: fmt(placed.end),
                start: fmt(placed.start),
                end: fmt(placed.end),
                workDurationMs: dur,
            };

            return replanAffectedRecursive({
                affectedOrders: rest,
                cur: nextCur,
                periods: nextPeriods,
                keepReplanning: true,
            });
        }

        // Unknown rowType: skip
        return replanAffectedRecursive({
            affectedOrders: rest,
            cur: nextCur,
            periods: nextPeriods,
            keepReplanning: true,
        });
    }

    // -------------------- Run chain replanning (if enabled + overlap exists) --------------------
    //console.log("[DEBUG] REPLAN=", REPLAN, "firstOverlap=", !!firstOverlap);

    if (firstOverlap !== undefined && REPLAN) {
        const anchor = new Date(updatePOData.plannedOrReplannedStartTime ?? updatePOData.plannedStartTime);

        // include anything that could be affected after anchor (same as your old approach)
        let affectedOrders = existingPlans.filter(
            (o) =>
                o.machineId === machineId &&
                o.productionOrderId !== productionOrderId &&
                ms(o.plannedOrReplannedEndTime) > ms(anchor)
        );

        // sort by start time
        affectedOrders.sort((a, b) => ms(a.plannedOrReplannedStartTime) - ms(b.plannedOrReplannedStartTime) || (a.productionOrderId ?? 0) - (b.productionOrderId ?? 0));

        const res = replanAffectedRecursive({
            affectedOrders,
            cur: { ...updatePOData },
            periods: [],
            keepReplanning: true,
        });

        periods = res.periods;
        const lastCur = res.cur;

        if (lastCur && lastCur.rowType !== 2) {
            periods.push({ ...lastCur });
            updatePOData = { ...lastCur };
        }
    }

    return { replannedOrder: updatePOData, replannedOrders: periods };
};

function parseShiftTs(s) {
    // matchar dina strängar "YYYY-MM-DD HH:mm:ss"
    return dayjs(s, "YYYY-MM-DD HH:mm:ss").valueOf();
}


export const buildShiftsForMachine = (rows, mId) => {
    // console.log("Building shifts for machine", mId, rows);
    return (rows || [])
        .filter((r) => r.machineId === mId)
        .map((r) => ({
            start: ms(parseShiftTs(r.startDate)),
            end: ms(parseShiftTs(r.endDate)),
            ref: r,
        }))
        .filter((w) => Number.isFinite(w.start) && Number.isFinite(w.end) && w.end > w.start)
        .sort((a, b) => a.start - b.start);
}

export const buildBlockers = (existingPlans) => {

    return (existingPlans || [])
        .filter((o) => o.rowType === 2)
        .map((o) => ({
            start: ms(o.plannedOrReplannedStartTime),
            end: ms(o.plannedOrReplannedEndTime),
            ref: o,
        }))
        .filter((b) => b.end > b.start)
        .sort((a, b) => a.start - b.start);
}

// Places an order:
// - start snaps into the next available shift time
// - work time is consumed only inside shifts
// - if any production chunk overlaps a blocker -> move start to blocker.end + gap and retry
export const  placeWithShiftsAndBlockers = ({ startMs, workDurationMs, shifts, blockers, gapMs, label }) =>{

    const snapToShift = (t) => {
        for (const w of shifts) {
            if (t < w.start) return w.start;
            if (t >= w.start && t < w.end) return t;
        }
        return null; // no more shift in horizon
    };

    const blockerAt = (t) => blockers.find((b) => t >= b.start && t < b.end);

    for (let guard = 0; guard < 300; guard++) {
        // 1) snap start into a shift
        let s = snapToShift(startMs);
        if (s == null) {
            return null;
        }

        // 2) if start is inside blocker, hop after blocker+gap and retry
        const b0 = blockerAt(s);
        if (b0) {
            startMs = b0.end + gapMs;
            continue;
        }

        // 3) consume workDuration across shifts
        let remaining = workDurationMs;
        let t = s;

        for (let i = 0; i < shifts.length && remaining > 0; i++) {
            const w = shifts[i];

            if (t < w.start) t = w.start;
            if (t >= w.end) continue;

            const chunk = Math.min(remaining, w.end - t);
            const proposedEnd = t + chunk;

            // 4) if production chunk overlaps a blocker -> move start after blocker+gap and restart (guard loop)
            const hit = blockers.find((b) => t < b.end && proposedEnd > b.start);
            if (hit) {
                startMs = hit.end + gapMs;
                remaining = -1;
                break;
            }

            remaining -= chunk;
            t = proposedEnd;
        }

        if (remaining === 0) return { start: s, end: t };

        // If we ran out of shifts in the horizon
        if (remaining > 0) {
            return null;
        }
    }

    console.warn("[placeWithShiftsAndBlockers] guard hit", { label, start: fmt(startMs) });
    return null;
}

function getWorkDurationMs(p, historicOeeData, defaultOee) {
    //if blocker calculate by start-end
    if (p.rowType === 2) {
        return ms(p.plannedOrReplannedEndTime) - ms(p.plannedOrReplannedStartTime);
    }

    if (typeof p.workDurationMs === "number") {
        return p.workDurationMs;
    }

    let itemOee = p.oeeValue || defaultOee 

    let result = ReCalculateEndTime(p, p.speedUnitTypeId, itemOee);
    let localIdealTimeToEnd = result.idealTimeToEnd;

    localIdealTimeToEnd = localIdealTimeToEnd * 60 * 1000; //convert minutes to ms

    return localIdealTimeToEnd;
}



